import useLogzIo from 'hooks/useLogzIo'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

const PathChangeLogger = () => {
  const location = useLocation()

  const log = useLogzIo()

  function urlCleaner(url) {
    return url.replace(/\/s\/[^/]+\//, '').replace(/\/[\d-]+/, '/xxx')
  }

  useEffect(() => {
    if (!document.location.origin.includes('localhostt')) {
      log({
        level: 'Info',
        message: 'DashboardPageVisit',
        additionalData: { uiPath: urlCleaner(location.pathname) }
      }).catch(err => console.warn('error while logging', err.toString()))
    }
  }, [location, log])

  return null
}

export default PathChangeLogger
